import type { ScreenModule } from "../../../app/screen-module";
import { RolesPage } from "../pages";

export default {
	id: "tenant-admin.roles",
	path: "/admin/roles",
	area: "tenant-admin",
	navGroup: "組織",
	label: "ロールと権限",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: RolesPage,
} satisfies ScreenModule;
